module.exports = __webpack_public_path__ + "static/media/wolfHowl.2ecdf25a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wolfHowl.jpg
// module id = 3269
// module chunks = 0